__webpack_require__.p = "/reports-translations-to-backend-migration-intervals/referrals-hub/";